import { LINKS } from "@consts";

import type { MenuLinkProps } from "@/types/global";

export type ShouldDisplayLink = "always" | "logged-in" | "logged-out";

export const NAVBAR_LINKS_GROUPS: {
	links: { link: MenuLinkProps; shouldDisplay: ShouldDisplayLink }[];
}[] = [
	{
		links: [
			{ link: LINKS.Pools, shouldDisplay: "always" },
			{ link: LINKS.Favorites, shouldDisplay: "always" },
		],
	},
	{
		links: [
			{ link: LINKS.Plans, shouldDisplay: "always" },
			{ link: LINKS.Login, shouldDisplay: "logged-out" },
		],
	},
];
